import React, { Component } from 'react';

import { trans } from '../../../../localization/index';
import PageTable, {
  PageTableCell,
  PageTableHeader,
  PageTableRow,
} from '../../../../components/Table/PageTable';
import { EnumPagingMode } from '../../../../constants/enum';

import TableEmpty from '../../../../components/Common/TableEmpty'


class WalletManagementTable extends Component {
  static renderHeader() {
    const columns = [
      {
        id: 'number',
        label: trans('merchant_wallet_header_stt'),
        width: '5%',
        textAlign: 'center',
      },
      {
        id: 'name',
        label: trans('merchant_wallet_header_name'),
      },
      {
        id: 'phone',
        label: trans('merchant_wallet_header_phone'),
      },
      {
        id: 'email',
        label: trans('merchant_wallet_header_email'),
      },
      {
        id: 'register_address',
        label: trans('merchant_wallet_header_register_address'),
      },
      {
        id: 'status',
        label: trans('common_status'),
      },
      {
        id: 'restaurant',
        label: trans('merchant_wallet_header_restaurant'),
        textAlign: 'center',
        width: '170px',
      },
      {
        id: 'control',
        label: trans('merchant_wallet_header_control'),
        textAlign: 'center',
        width: '290px',
      },
    ];
    return <PageTableHeader columns={columns} />;
  }

  renderRow = (row, index) => {
    const {
      getListUserWalletRestaurant,
      openUpdateUserWallet,
      resendActivationEmailUserWallet,
    } = this.props;
    const {
      airpay_store_id: airpayStoreId,
      owner_name: ownerName,
      owner_phone: ownerPhone,
      address,
      owner_email: ownerEmail,
      status,
    } = row;
    return (
      <PageTableRow key={airpayStoreId}>
        <PageTableCell textAlign="center" className="">
          {index}
        </PageTableCell>
        <PageTableCell textAlign="left">{ownerName}</PageTableCell>
        <PageTableCell className="left">{ownerPhone}</PageTableCell>
        <PageTableCell textAlign="left">{ownerEmail}</PageTableCell>
        <PageTableCell textAlign="left">{address}</PageTableCell>
        <PageTableCell textAlign="left">
          {status === 1 ? trans('active_text') : trans('inactive_text')}
        </PageTableCell>
        <PageTableCell textAlign="center">
          <button
            type="button"
            className="btn btn-white btn-row-wallet m-1"
            onClick={() => getListUserWalletRestaurant(airpayStoreId)}
          >
            <i className="fa fa-list-ul pr-10" />
            {trans('merchant_wallet_view_restaurant')}
          </button>
        </PageTableCell>
        <PageTableCell textAlign="center">
          <button
            type="button"
            className="btn btn-red btn-row-wallet m-1"
            onClick={() => openUpdateUserWallet(airpayStoreId, row)}
          >
            {trans('merchant_wallet_update')}
          </button>
          {status === 0 && (
            <button
              type="button"
              className="btn btn-white btn-row-wallet m-1"
              onClick={() =>
                resendActivationEmailUserWallet(airpayStoreId, ownerEmail)
              }
            >
              <i className="fa fa-paper-plane pr-10" />
              {trans('merchant_wallet_resent_email')}
            </button>
          )}
        </PageTableCell>
      </PageTableRow>
    );
  };

  static renderEmpty() {
    return (
      <PageTableRow>
        <PageTableCell colSpan={20} noPadding>
          <TableEmpty  txt="np_order_not_found" />
        </PageTableCell>
      </PageTableRow>
    );
  }

  render() {
    const { table, getList, changePageSize, changeActivePage } = this.props;
    return (
      <PageTable
        paginationMode={EnumPagingMode.SELF_PAGING.id}
        table={table}
        renderHeader={WalletManagementTable.renderHeader}
        renderRow={this.renderRow}
        renderEmpty={WalletManagementTable.renderEmpty}
        getList={getList}
        changePageSize={changePageSize}
        changeActivePage={changeActivePage}
      />
    );
  }
}

export default WalletManagementTable;



// WEBPACK FOOTER //
// ./foody/src/pages/MerchantWallet/WalletManagement/components/WalletManagementTable.jsx